/**
 * Serialize a value to pretty-printed JSON with object keys sorted recursively.
 *
 * Audit log snapshots originate from Go `structpb.Struct` maps, whose key order
 * is non-deterministic. Sorting keys before diffing keeps unchanged fields from
 * appearing as removed/added purely because the two snapshots serialized their
 * keys in a different order. Array element order is preserved; only object keys
 * are sorted, using a deterministic code-unit comparison.
 */
export function stableStringify(value: unknown): string {
  return JSON.stringify(
    value,
    (_key: string, val: unknown) => {
      if (val && typeof val === "object" && !Array.isArray(val)) {
        return Object.fromEntries(
          Object.entries(val).sort(([a], [b]) => {
            if (a < b) {
              return -1;
            }
            if (a > b) {
              return 1;
            }
            return 0;
          })
        );
      }
      return val;
    },
    2
  );
}
